<template>
    <div class="catcheck">
        <cube-page type="catcheck-view" title="订单确认">
            <div slot="content">
                <div class="card-root-c" v-for="(item, idx) in goods_list" :key="idx">
                    <div v-if="item.show_error != 0" class="goods_err_div">{{item.show_error_text}}</div>
                    <van-card :class="item.show_error == 0 ? '' : 'error_goods'"
                              :price="item.goods_price + ((act.exchange_typedata=='qualification')?'  资格兑换':('  积分:'+item.goods_sku.goods_score))"
                              :title="item.goods_name" :num="item.total_num"
                              :desc="item.goods_sku.goods_attr ? item.goods_sku.goods_attr :'默认规格'"
                              :centered="true" :lazy-load="true" :thumb="item.goods_sku.spec_image==''? item.image:item.goods_sku.img_show">
                    </van-card>
                </div>

                <!-- 这里是总计 和 邮费 -->
                <van-cell-group class="vcg-c">
                    <van-cell title="商品数总计：" :value="order_total_num" />
                    <van-cell v-if="convertibility&&convertibility.exchangedata=='score'" title="需要积分总计：" class="pric-cell" :value="order_total_score+'分'" />
                    <van-cell v-if="convertibility&&convertibility.exchangedata=='score'" title="您本次活动拥有积分：" class="pric-cell" :value="convertibility.countnumber+'分'" />
                    <van-cell v-if="convertibility&&convertibility.exchangedata=='qualification'" title="您本次活动拥有兑换资格：" class="pric-cell" :value="convertibility.countnumber" />
                    <van-cell v-if="!convertibility" title="您本次活动：" class="pric-cell" value="没有任何剩余兑换量" />
                    <van-cell title="商品总价值：" :value="'￥'+order_total_price" />
                    <van-cell title="快递费用：" :value="express_price==0 ? '免邮费或未查询到运费' : '＋ ￥' + express_price" />
                    <van-cell title="共需补差价：" class="pric-cell chajia" :value="'￥'+show_chajia" />
                </van-cell-group>

                <van-submit-bar
                        :label="(act.exchange_typedata=='qualification')?('资格:'+order_total_num):('积分:'+order_total_score)"
                        :price="order_pay_price*100"
                        button-text="提交订单"
                        @submit="onSubmit" :loading="disabled"
                >
                    <van-tag size="large" class="tagadress" color="#6d189e" @click="MangerAdress">管理地址</van-tag>
                    <span slot="tip" v-if="address">
				    <van-icon class='ico-ad' name="logistics"/><span class='ab_mt'>{{address.Area.province}}{{address.Area.city}}{{address.Area.region}} - {{address.detail}}</span><br>
   					<van-icon class='lianxirentip ico-ad' name="phone"/><span class='lianxirentip ab_mt'>{{address.name}} : {{address.phone}}</span>
				  </span>
                    <span slot="tip" v-else>
				    <van-icon class='ico-ad' name="logistics"/><span class='ab_mt'>未曾增加收货地址</span><br>
   					<van-icon class='lianxirentip ico-ad' name="phone"/><span class='lianxirentip ab_mt'>请点击管理地址增加</span>
				  </span>
                </van-submit-bar>

                <cube-view></cube-view>
            </div>
        </cube-page>
    </div>

</template>

<script>
    import CubePage from './TP/cube-page.vue'
    import CubeView from '@/components/TP/cube-view'
    import * as util from '@/utils/network'

    export default {
        components: {
            CubePage,
            CubeView,
        },
        data() {
            return {
                goods_list: [], // 商品列表
                order_total_num: 0,
                order_total_price: 0,
                order_total_score:0,

                express_price:0,
                order_pay_price:0,

                address:null,
                disabled: false,

                has_error:false,
                error_msg:"",

                forpagedata:[],
                act:[],

                convertibility:null
            };
        },
        computed:{
            show_chajia:function(){
                if(this.convertibility){
                    if(this.convertibility.exchangedata=='score'){
                        var score = this.order_total_score - this.convertibility.countnumber
                        var money = 0.00;
                        if(score>=0){
                            money = Number(score/this.act.score_scalenumber+this.express_price).toFixed(2);
                        }else{
                            money = Number(this.express_price).toFixed(2);
                        }

                        return money;
                    }else{
                        var last_count = this.order_total_num - this.convertibility.countnumber
                        //这里根据 购物车商品进行排序
                        var tmp_cart_goodslist = this.goods_list.sort(this.sortBy('goods_price',false));
                        //console.log(tmp_cart_goodslist)
                        var money = 0
                        tmp_cart_goodslist.forEach(function(value,index,array){
                            if(index < last_count){
                                money+=Number(value['goods_price'])
                            }
                        })
                        money=Number(money+this.express_price).toFixed(2);
                        return money
                    }
                }else{
                    return 0.00
                }

            }
        },
        created: function () {
            this.act = this.$store.getters.getAct

            //forpagedata 专门用于直接购买的
            this.forpagedata.type = this.$route.query.type
            this.forpagedata.goods_id = this.$route.query.goods_id
            this.forpagedata.goods_num = this.$route.query.goods_num
            this.forpagedata.goods_sku_id = this.$route.query.goods_sku_id

            //这里获得用户本身自己的兑换资格或积分
            let that = this;
            var url = "/addons/qrcodeshop/api.activity/get_my_convertibility"
            util.get(url,{id:this.act.id},
                function (result) {
                    that.convertibility = result.data
                },
            );

            if(this.$route.query.type=='cart'){
                this.getCartList();
            }
            //事件触发
            this.$root.eventHub.$on('changeadress', (data)=>{
                if(this.forpagedata.type=='cart'){
                    this.getCartList();
                }else{
                    this.getBuyNowdata();
                }
            })
        },
        beforeDestroyed() {
            this.$root.eventHub.$off('changeadress')
        },
        watch:{
            "$store.state.act": function(){
                this.act = this.$store.getters.getAct
            },
        },
        methods: {
            /**数组根据数组对象中的某个属性值进行排序的方法
             * 使用例子：newArray.sort(sortBy('number',false)) //表示根据number属性降序排列;若第二个参数不传递，默认表示升序排序
             * @param attr 排序的属性 如number属性
             * @param rev true表示升序排列，false降序排序
             * */
            sortBy: function(attr,rev){
                //第二个参数没有传递 默认升序排列
                if(rev ==  undefined){
                    rev = 1;
                }else{
                    rev = (rev) ? 1 : -1;
                }

                return function(a,b){
                    a = a[attr];
                    b = b[attr];
                    if(a < b){
                        return rev * -1;
                    }
                    if(a > b){
                        return rev * 1;
                    }
                    return 0;
                }
            },
            /** 购物车列表 */
            getCartList: function () {
                let that = this;
                var url = "/addons/qrcodeshop/api.cart/getlists"
                util.get(url,{},
                    function (result) {
                        that.goods_list = result.data.goods_list
                        that.order_total_num = result.data.order_total_num
                        that.order_total_price = result.data.order_total_price
                        that.order_total_score = result.data.order_total_score

                        that.address = result.data.address
                        that.express_price = result.data.express_price
                        that.order_pay_price = result.data.order_pay_price

                        that.has_error = result.data.has_error
                        that.error_msg = result.data.error_msg
                        //提示下架的商品
                        if (result.data.error_msg) {
                            that.$toast.fail(result.data.error_msg);
                        }
                    },
                );
            },
            MangerAdress(){
                this.$router.push({path: 'showactcartcheck/showactadresslist'})
            },
            onSubmit(){
                //提交订单
                let that = this;

                if (that.goods_list.length==0) {
                    that.$toast.fail('此订单无商品');
                    return false;
                }

                if (that.disabled) {
                    return false;
                }

                if (that.has_error) {
                    that.$toast.fail(that.error_msg);
                    return false;
                }
                that.disabled = true;

                if(this.$route.query.type=='cart'){
                    //提交订单
                    var url = "/addons/qrcodeshop/api.order/cart_pay"
                    util.get(url,{type:'gzh',actid:that.act.id},
                        function (result) {
                            console.log(result);
                            that.disabled = false;
                            if(result.code==1008){
                                //这里不直接跳转了，提示框  为绑定微信，跳转到my页面 绑定微信
                                that.$dialog.confirm({
                                    title: '未通过微信登录',
                                    message: '您的账号未绑定微信号，请跳转后绑定微信号再进入未支付订单继续支付。'
                                }).then(() => {
                                    that.$router.push({path: '../showactmy'})
                                }).catch(() => {
                                    that.$router.push({path: '../showactmy/showactmyorder'})
                                });
                            }else{
                                //这里发起支付
                                //console.log('这里能够符合支付条件');
                                if(that.show_chajia==0.00){
                                    that.$toast('恭喜，订单提交成功');
                                    that.$router.push({path: '../showactmy/showactmyorder'})
                                }else{
                                    that.wx_pay_fun(result.data);
                                }

                            }
                        },
                        function (result) {
                            console.log(result);
                        },
                        function () {
                            that.disabled = false;
                        },
                    );
                }
            },
            wx_pay_fun(re){
                var vm = this;
                if (typeof WeixinJSBridge == "undefined"){//微信浏览器内置对象。参考微信官方文档
                    vm.$toast('请使用微信打开');
                    vm.$router.push({path: '../showactmy/showactmyorder'})
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(re), false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(re));
                        document.attachEvent('onWeixinJSBridgeReady',vm.onBridgeReady(re));
                    }
                }else{
                    vm.onBridgeReady(re);
                }
            },
            onBridgeReady(data){
                var vm = this;
                //alert(JSON.stringify(data))
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',{
                        "appId": data.appId,
                        "nonceStr": data.nonceStr,
                        "package": data.package,
                        "signType": data.signType,
                        "paySign": data.paySign,
                        "timeStamp": data.timestamp
                    },
                    function(res){
                        console.log(res.err_msg)
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            vm.$toast('恭喜，支付成功');

                        }else{
                            vm.$toast('未支付或支付失败');
                        }
                        vm.$router.push({path: '../showactmy/showactmyorder'})
                    }
                );
            }
        }
    }
</script>

<style scoped>
    .catcheck{
        height: 100%;
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 18;
    }
    .catcheck .cube-page >.wrapper .content {
        margin: 0;
    }
    .catindex .catcheck .card-root-c {
        padding-top: 0px;
        position: relative;
    }
    .catcheck .cube-page >.wrapper{
        background-color: #edeff4;
    }
    .catcheck .van-stepper__input[disabled] {
        color:white!important;
        background-color:#6d189e!important;
    }
    .catcheck .goods_err_div{
        position:absolute;
        z-index:9;
        font-size:2em;
        line-height:100px;
        text-align:center;
        width:100%;
        color: #6d189e;
        letter-spacing:1.2em;
        font-weight:bolder;
        text-indent : 3em;
    }
    .catindex .catcheck .van-submit-bar{
        bottom: 0;
    }
    .catcheck .pric-cell .van-cell__value span{
        color:#f44;
    }
    .catcheck .vcg-c{
        padding-top: 10px;
        margin-bottom: 108px;
    }
    .catcheck .tagadress
    {
        margin-left: 1em;
    }
    .catcheck .lianxirentip{
        color: #6d189e;
    }
    .catcheck .ico-ad{
        font-size: 12px!important;
        margin-right:0.68em;
    }
    .catcheck .ab_mt{
        margin-top: -1px;
        position: absolute;
    }
    .chajia{
        font-size: 1.1em;
        font-weight: bold;
    }
</style>